// Staff roster for the /team page. Ludwig's photo is a real photograph; the
// other entries are fictional, their photos AI-generated faces of people who
// do not exist (thispersondoesnotexist.com, StyleGAN2). The *-wall.jpg versions
// shown on the page put each cut-out in front of a celp logo wall.
export default [
  { name: 'Ludwig Prager', photo: '/img/staff/ludwig-prager-wall.jpg', initials: 'LP',
    linkedin: 'https://www.linkedin.com/in/ludwig-prager-a90a7588/',
    role: { en: 'CEO', de: 'CEO' } },
  { name: 'Sophie Bergmann', photo: '/img/staff/sophie-bergmann-wall.jpg',
    role: { en: 'Head of Sales', de: 'Leiterin Vertrieb' } },
  { name: 'Markus Weidner', photo: '/img/staff/markus-weidner-wall.jpg',
    role: { en: 'Chief Architect', de: 'Chefarchitekt' } },
  { name: 'Yusuf Haddad', photo: '/img/staff/yusuf-haddad-wall.jpg',
    role: { en: 'Working Student, Software Development', de: 'Werkstudent, Softwareentwicklung' } },
  { name: 'Robin Vogel', pronouns: 'they/them', photo: '/img/staff/robin-vogel-wall.jpg',
    role: { en: 'Head of People & Culture', de: 'Leitung People & Culture' } },
]
